export default "__VITE_ASSET__06xgw5JL__"